import React from "react";
import { ArrowRight } from "lucide-react";

const LOGO =
  "https://customer-assets.emergentagent.com/job_cbd3e065-04c9-49ae-9568-054bf18e1f81/artifacts/nukkl7c1_1000648567.png";

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative overflow-hidden"
      data-testid="hero-section"
    >
      {/* Subtle yellow corner accent */}
      <div
        aria-hidden="true"
        className="absolute -top-24 -right-24 h-[380px] w-[380px] rounded-full opacity-60 blur-3xl"
        style={{ background: "var(--kw-yellow)" }}
      />
      <div
        aria-hidden="true"
        className="absolute -bottom-32 -left-32 h-[320px] w-[320px] rounded-full opacity-40 blur-3xl"
        style={{ background: "var(--kw-yellow)" }}
      />

      <div className="container-kw relative pt-20 pb-24 md:pt-28 md:pb-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-7 kw-fade-in">
            <div className="eyebrow mb-6">Product Company · Est. India</div>
            <h1
              className="font-display font-black tracking-tight text-[color:var(--kw-black)] text-5xl sm:text-6xl lg:text-7xl leading-[1.02]"
              data-testid="hero-headline"
            >
              Building <span className="relative inline-block">
                <span className="relative z-10">Digital Platforms</span>
                <span
                  aria-hidden="true"
                  className="absolute left-0 right-0 bottom-1 h-3 md:h-4 -z-0"
                  style={{ background: "var(--kw-yellow)" }}
                />
              </span>{" "}
              That Serve People
            </h1>
            <p className="mt-8 text-lg md:text-xl text-[color:var(--kw-muted)] max-w-2xl leading-relaxed">
              We create and operate platforms like{" "}
              <span className="text-[color:var(--kw-black)] font-medium">
                CoinsFlu
              </span>{" "}
              and{" "}
              <span className="text-[color:var(--kw-black)] font-medium">
                Harday
              </span>{" "}
              with a focus on simplicity, fairness, and meaningful user value.
            </p>
            <div className="mt-10 flex flex-wrap items-center gap-4">
              <a
                href="#contact"
                className="btn-pill btn-primary"
                data-testid="hero-contact-cta"
              >
                Contact Us <ArrowRight className="h-4 w-4" />
              </a>
              <a
                href="#products"
                className="btn-pill btn-outline"
                data-testid="hero-products-cta"
              >
                Our Products
              </a>
            </div>
          </div>

          <div className="lg:col-span-5 flex justify-center lg:justify-end kw-fade-in">
            <div
              className="relative"
              style={{ animationDelay: "120ms" }}
            >
              <div
                className="absolute inset-0 rounded-[2rem] rotate-3"
                style={{ background: "var(--kw-yellow)" }}
                aria-hidden="true"
              />
              <img
                src={LOGO}
                alt="King's Wake Digital Logo"
                className="relative h-64 w-64 md:h-80 md:w-80 rounded-[2rem] object-cover shadow-[0_30px_80px_-20px_rgba(0,0,0,0.25)]"
                data-testid="hero-logo"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
